import * as React from 'react'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import i18n from 'modules/core/lib/i18n'

import Actions from 'modules/goals/pages/performance/GoalPage/_Actions'
import type GoalConfig from 'modules/goals/store/models/GoalConfig'
import { STATUS } from 'modules/goals/store/models/GoalConfig'

interface StatusButtonProps {
  goalConfig: GoalConfig
  onClick: (status: string) => () => void
  showActions?: boolean
}

const StatusButton = observer(({ goalConfig, onClick, showActions }: StatusButtonProps) => {
  if (!showActions) return null

  if (!goalConfig.policy.can('editGoalConfig')) return null

  const name = (status: string): string => {
    switch (status) {
      case STATUS.closed:
        return i18n.t('surveys.goals.show.reactivate')

      case STATUS.active:
      default:
        return i18n.t('surveys.goals.show.close')
    }
  }

  return (
    <Button onClick={onClick(goalConfig.attributes.status)} type="secondary">
      {name(goalConfig.attributes.status)}
    </Button>
  )
})
interface HeaderProps {
  goalConfig: GoalConfig
  showActions?: boolean
}

const Header = ({ goalConfig, showActions }: HeaderProps) => {
  const { performAction } = useAsyncAction(
    (status) =>
      goalConfig.save({
        status: status,
      }),
    {
      successFlash: false,
    }
  )

  const onClick = (status: string): (() => void) => {
    switch (status) {
      case STATUS.closed:
        return () => {
          performAction(STATUS.active)
        }

      case STATUS.active:
      default:
        return () => {
          performAction(STATUS.closed)
        }
    }
  }

  return (
    <Box
      flexDirection="row"
      justifyContent="spaceBetween"
      alignItems="center"
      background="grey200"
      paddingX="s32"
      paddingY="s24"
      border={{
        bottom: {
          width: 's1',
          style: 'solid',
          color: 'grey400',
        },
      }}
    >
      <Text.Header2>{goalConfig.attributes.name}</Text.Header2>
      <Box flexDirection="row" gap="s4">
        <StatusButton showActions={showActions} goalConfig={goalConfig} onClick={onClick} />
        <Actions goalConfig={goalConfig} />
      </Box>
    </Box>
  )
}

export default observer(Header)
